<div class="row">
    <div class="col-xs-12 col-lg-9">
        <div class="alert alert-danger">
            <span class="fal fa-4x fa-hand-paper"></span>
            <br /><br />

            @if (page || errorMessage) {
                @if (page) {
                    <p>Unfortunately, there was an error when attempting to access this page.</p>
                    <p>
                        You tried to access <strong>{{ page }}</strong>.
                    </p>
                }
                @if (errorMessage) {
                    <p>{{ errorMessage }}</p>
                }
            } @else {
                <p>Unfortunately, something has gone wrong.</p>
            }

            <div role="alert"
                 class="alert alert-warning">Please contact your {{ platformName }} administrator, coach or adapt support for assistance in
                resolving this issue.</div>
        </div>
    </div>
</div>
